import { Divider, Pagination } from '@reveni-io/reveni-ui'

import PageSizeSelector from '@/common/components/PageSizeSelector/PageSizeSelector'

import * as Styles from './styles'

const TopicDrawerPaginator = ({ show, page, pageSize, totalPages, previous, next, onChangePage, onChangePageSize }) => {
  if (!show) return null

  return (
    <>
      <Divider />
      <Styles.Container>
        <PageSizeSelector value={pageSize} onChange={onChangePageSize} />
        <Pagination page={page} count={totalPages} previous={previous} next={next} onChangePage={onChangePage} />
      </Styles.Container>
    </>
  )
}

export default TopicDrawerPaginator
